import {Component} from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DateValidator} from 'frontier/nucleus';
import {
  ConfirmIconButtonComponent
} from 'frontier/browserkit/src/lib/components/confirm-icon-button/confirm-icon-button.component';
import {
  DateElementComponent
} from '../../components/control/form-control/dynamic-form/form-element/date-element/date-element.component';
import {DialogHeaderComponent} from 'frontier/browserkit/src/lib/components/dialog-header/dialog-header.component';
import {MatError} from '@angular/material/form-field';

@Component({
  selector: 'lib-date-range-picker-dialog',
  templateUrl: './date-range-picker-dialog.component.html',
  styleUrl: './date-range-picker-dialog.component.css',
  standalone: true,
  imports: [DialogHeaderComponent, MatDialogContent, DateElementComponent, MatDialogActions, ConfirmIconButtonComponent, MatError]
})
export class DateRangePickerDialogComponent {
  dateRangeForm = new FormGroup({
    fromDate: new FormControl(null, [Validators.required, DateValidator.isoFormat]),
    toDate: new FormControl(null, [Validators.required, DateValidator.isoFormat])
  }, {validators: (formGroup) => {
      const fromDate = formGroup.get('fromDate');
      const toDate = formGroup.get('toDate');
      return fromDate.value && toDate.value && fromDate.value > toDate.value ? {invalidDateRange: true} : null;
    }})


  constructor(
    public dialogRef: MatDialogRef<any>
  ) {
    this.dateRangeForm.patchValue({fromDate: '', toDate: ''})
  }

  confirm() {
    this.dialogRef.close(this.dateRangeForm.value);
  }
}
